// Phone-format helpers shared across pages.
export const buildWhatsAppLink = (raw) => {
  if (!raw) return null;
  const digits = String(raw).replace(/\D/g, '');
  if (!digits) return null;
  const withCC = digits.length === 10 ? `91${digits}` : digits;
  return `https://wa.me/${withCC}`;
};

export const buildTelLink = (raw) => {
  if (!raw) return null;
  const digits = String(raw).replace(/[^\d+]/g, '');
  return digits ? `tel:${digits}` : null;
};

export const fmtInr = (n) =>
  `₹${(Number(n) || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;

const normPhone = (raw) => { const d = String(raw || '').replace(/\D/g, ''); return d.length > 10 ? d.slice(-10) : d; };
const NOISE = new Set(['pvt', 'private', 'ltd', 'limited', 'llp', 'inc', 'co', 'company', 'the', 'and', '&']);
const normCompany = (name) => String(name || '').toLowerCase().replace(/[^a-z0-9 ]/g, ' ').split(/\s+/).filter((t) => t && !NOISE.has(t)).join(' ');

/** Same mobile + same company (normalised) → returns the clashing candidate, else null. */
export const findDuplicate = (candidates, number, company, excludeId = null) => {
  const p = normPhone(number);
  const c = normCompany(company);
  if (p.length < 10 || !c) return null;
  return candidates.find((x) => x.id !== excludeId && normPhone(x.candidate_number) === p && normCompany(x.company_name) === c) || null;
};

// Status options for the candidate row.
export const STATUS_OPTIONS = ['Pending', 'Joined', 'Declined', 'Fired', 'Left'];

export const getStatusBadgeClass = (status) => {
  const baseClass = 'px-3 py-1 rounded-md border-2 border-[#0A0A0A] text-xs font-bold uppercase';
  switch ((status || '').toLowerCase()) {
    case 'joined':
      return `${baseClass} bg-[#4ADE80] text-[#0A0A0A]`;
    case 'pending':
      return `${baseClass} bg-[#FDE047] text-[#0A0A0A]`;
    case 'declined':
      return `${baseClass} bg-[#F87171] text-white`;
    default:
      return `${baseClass} bg-[#93C5FD] text-[#0A0A0A]`;
  }
};
